import { Box, Typography } from '@iheartjane/reefer';
import { titleCase } from '@iheartjane/utils';

import { useMenu } from '@jane/shared-ecomm/providers';
import { formatTime } from '@jane/shared/util';

import { StyledGrid } from './MenuHeader.styles';

export const MenuSchedule = () => {
  const {
    store: { working_hours },
  } = useMenu();

  const schedule = working_hours.map((schedule, index) => {
    const { day, period } = schedule;
    const startTime =
      period?.from &&
      formatTime({
        time: period.from,
        outputFormat: 'h:mm aaa',
        inputFormat: 'H:mm',
      });
    const endTime =
      period?.to &&
      formatTime({
        time: period.to,
        outputFormat: 'h:mm aaa',
        inputFormat: 'H:mm',
      });
    return (
      <StyledGrid key={day} pt={index !== 0 ? 4 : 0}>
        <Typography>{titleCase(day)}</Typography>
        {!!startTime && !!endTime ? (
          <Typography color="text-light" whiteSpace="nowrap">
            {startTime} - {endTime}
          </Typography>
        ) : (
          <Typography color="text-light">Closed</Typography>
        )}
      </StyledGrid>
    );
  });

  return <Box pt={8}>{schedule}</Box>;
};
